<div nz-col class="gutter-row pr-3" *ngIf="hasMissingValueKeys">
	<div *ngIf="hasAnyMissingValue || !finishedAndLocked" nz-dropdown nzTrigger="click" [nzDisabled]="disabled" [nzDropdownMenu]="menu" nzPlacement="bottomRight"
			class="icon-inboxed fehlwert no-background" [ngClass]="{'active': hasAnyMissingValue, 'dropdown': !finishedAndLocked || missingValueKeysAmount > 1}"
	>
		<button *ngIf="!finishedAndLocked" nz-button [nzType]="'default'" [ngClass]="{'bordered': !hasAnyMissingValue, 'active': hasAnyMissingValue}" class="fehlwert" [disabled]="disabled">
			<span [ngClass]="{'inactive': !hasAnyMissingValue}">
				<workflow-missing-value-icon></workflow-missing-value-icon>
			</span>
		</button>
		<button *ngIf="finishedAndLocked && hasAnyMissingValue" class="active fehlwert" [disabled]="missingValueKeysAmount < 2 || disabled" nz-button [nzType]="'default'">
			<span class="active"><workflow-missing-value-icon></workflow-missing-value-icon></span>
		</button>
	</div>
</div>

<nz-dropdown-menu #menu="nzDropdownMenu">
	<ul nz-menu>
		<li *ngIf="hasAnyMissingValue" nz-menu-item class="no-hover">
			<b>{{ 'workflow.missing_value_in_use' | translate }}</b>
		</li>
		<li *ngIf="!hasAnyMissingValue" nz-menu-item class="no-hover">
			<b>{{ 'word.missing_value' | translate }}</b>
		</li>
		<li *ngIf="!finishedAndLocked" nz-menu-divider></li>
		<ng-container *ngFor="let pair of missingValueKeyLabelPairs">
			<workflow-missing-value-list-item
					[appWorkflowItemKey]="pair.key"
					[finishedAndLocked]="finishedAndLocked" [meta]="pair"
			></workflow-missing-value-list-item>
		</ng-container>
	</ul>
</nz-dropdown-menu>

